export const COUNTRY_CODES = {
  SPAIN: 'ES',
};
